import type { SelectOption } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useCallback, useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { ALL_USER_DOCUMENT_CATEGORIES_QUERY } from '@/modules/users/queries'
import type {
  AllUserDocumentCategorysQuery,
  UserDocumentCategoryNode,
} from '@/modules/users'
import type { SelectMultipleProps } from './SelectMultiple'
import { SelectMultiple } from './SelectMultiple'

interface SelectMultipleUserDocumentCategoriesProps
  extends Omit<
    SelectMultipleProps<string, UserDocumentCategoryNode>,
    'options'
  > {}

export const SelectMultipleUserDocumentCategories: React.FC<
  SelectMultipleUserDocumentCategoriesProps
> = ({ ...selectProps }) => {
  const { placeholder } = useTranslate({
    placeholder: 'common.select-salary-code',
  })
  const { data, loading } = useQuery<AllUserDocumentCategorysQuery>(
    ALL_USER_DOCUMENT_CATEGORIES_QUERY
  )

  const getLabel = useCallback((category: UserDocumentCategoryNode) => {
    return <span className="name">{category.name}</span>
  }, [])

  const options = useMemo<
    SelectOption<string, UserDocumentCategoryNode>[]
  >(() => {
    if (!data) return []

    const options = data.allUserDocumentCategories.edges.map(
      ({ node: userDocumentCategory }) => ({
        value: userDocumentCategory.id,
        label: getLabel(userDocumentCategory),
        extra: userDocumentCategory,
      })
    )
    return options
  }, [data, getLabel])

  return (
    <SelectMultiple
      options={options}
      loading={loading}
      placeholder={placeholder}
      filterBackground="white"
      optionHoverBackground="white"
      {...selectProps}
    />
  )
}
